import { task, user } from '@/model/qsadminapi/QsAdminApiModuleModel'
import { DataGridTypes } from 'devextreme-react/cjs/data-grid'
import { EdmLiteral } from 'devextreme/common/data'

export const calculateAusiliariValue = (rowData: task) => {
  let ausiliari: string = ''
  rowData.tecnici?.map((tecnico: user) => {
    ausiliari = `${ausiliari + tecnico.fullname} `
  })
  return ausiliari.trim()
}

export const calculateAusiliariFilterExpression = (
  filterValue: any,
  selectedFilterOperation: string | null,
  target: string,
): string | (() => any) | Array<any> => {
  console.log('FLT', filterValue, selectedFilterOperation, target)

  if (target === 'filterBuilder' || target === 'filterRow') {
    switch (selectedFilterOperation) {
      case '=': {
        return [[new EdmLiteral(`tecnici/any(a: a/fullname eq '${filterValue}')`), '=', true]]
      }
      case '<>': {
        return [[new EdmLiteral(`tecnici/any(a: a/fullname eq '${filterValue}')`), '=', false]]
      }
      case 'contains':
      case 'startswith':
      case 'endswith': {
        return [[new EdmLiteral(`tecnici/any(a: ${selectedFilterOperation}(a/fullname, '${filterValue}'))`), '=', true]]
      }
      default: {
        // caso notcontains
        return [[new EdmLiteral(`tecnici/any(a: contains(a/fullname, '${filterValue}'))`), '=', false]]
      }
    }
  } else if (target === 'search' || target === 'headerFilter') {
    return [[new EdmLiteral(`tecnici/any(a: contains(a/fullname, '${filterValue}'))`), '=', true]]
  }

  return filterValue
}

export const cellRenderAusiliari = (cellData: DataGridTypes.ColumnCellTemplateData) => {
  const data: task = cellData.data
  return (
    <>
      {data.tecnici?.map((impiegato: user, index: number) => {
        return (
          <div className={`dx-tag-content custom-tag-padding`} key={index}>
            <span>{impiegato.fullname ?? `${impiegato.nome ?? ''} ${impiegato.cognome ?? ''}`.trim()}</span>
          </div>
        )
      })}
    </>
  )
}
